import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { APP_STORE_URLS } from '../../constants/appStores';
import phoneImg from './assets/phone.png';
import qrImg from './assets/qr.svg';
import classes from './MobileAppBanner.module.scss';

const FEATURES = ['visa', 'payments', 'purchases'];

const GooglePlayGlyph = () => (
  <svg width='20' height='20' viewBox='0 0 24 24' aria-hidden='true'>
    <path
      d='M3.609 1.814 13.792 12 3.61 22.186a1.5 1.5 0 0 1-.61-1.211V3.025a1.5 1.5 0 0 1 .609-1.211Z'
      fill='#2196F3'
    />
    <path
      d='m17.44 8.409-3.09 3.59.002.001 3.089 3.59 3.79-2.159a1.5 1.5 0 0 0 0-2.863l-3.79-2.159Z'
      fill='#FFC107'
    />
    <path
      d='M3.61 22.186a1.5 1.5 0 0 0 1.715.148l12.115-6.744-3.09-3.59L3.61 22.186Z'
      fill='#F44336'
    />
    <path
      d='M5.325 1.666a1.5 1.5 0 0 0-1.716.148L14.35 12l3.09-3.591L5.325 1.666Z'
      fill='#4CAF50'
    />
  </svg>
);

const AppStoreGlyph = () => (
  <svg width='20' height='20' viewBox='0 0 24 24' fill='#ffffff' aria-hidden='true'>
    <path d='M17.564 12.65c-.02-2.154 1.761-3.192 1.842-3.241-1.003-1.465-2.566-1.665-3.122-1.687-1.329-.135-2.594.784-3.269.784-.68 0-1.717-.764-2.82-.742-1.45.021-2.788.844-3.534 2.141-1.507 2.612-.385 6.475 1.086 8.596.719 1.04 1.573 2.205 2.693 2.164 1.082-.045 1.489-.7 2.795-.7 1.305 0 1.674.7 2.815.676 1.162-.02 1.898-1.055 2.605-2.1.82-1.204 1.158-2.378 1.178-2.438-.026-.012-2.25-.863-2.27-3.453ZM15.422 6.31c.598-.723.999-1.727.89-2.725-.86.035-1.903.574-2.52 1.296-.555.638-1.04 1.66-.908 2.64.959.074 1.94-.488 2.538-1.211Z' />
  </svg>
);

const MobileAppBanner = () => {
  const { t } = useTranslation();
  const [activeFeature, setActiveFeature] = useState('visa');

  return (
    <section
      className={classes.banner}
      aria-label={t('pages.main.mobileAppBanner.aria')}
    >
      <div className={classes.inner}>
        <div className={classes.copy}>
          <h2 className={classes.head}>{t('pages.main.mobileAppBanner.title')}</h2>
          <p className={classes.sub}>{t('pages.main.mobileAppBanner.subtitle')}</p>
          <div className={classes.stores}>
            <a
              className={classes.store}
              href={APP_STORE_URLS.ANDROID}
              target='_blank'
              rel='noopener noreferrer'
              aria-label={t('pages.main.mobileAppBanner.stores.googlePlayAria')}
            >
              <span className={classes.storeMark}>
                <GooglePlayGlyph />
              </span>
              <span>
                <div className={classes.storeT1}>
                  {t('pages.main.mobileAppBanner.stores.getItOn')}
                </div>
                <div className={classes.storeT2}>
                  {t('pages.main.mobileAppBanner.stores.googlePlay')}
                </div>
              </span>
            </a>
            <a
              className={classes.store}
              href={APP_STORE_URLS.IOS}
              target='_blank'
              rel='noopener noreferrer'
              aria-label={t('pages.main.mobileAppBanner.stores.appStoreAria')}
            >
              <span className={classes.storeMark}>
                <AppStoreGlyph />
              </span>
              <span>
                <div className={classes.storeT1}>
                  {t('pages.main.mobileAppBanner.stores.downloadOn')}
                </div>
                <div className={classes.storeT2}>
                  {t('pages.main.mobileAppBanner.stores.appStore')}
                </div>
              </span>
            </a>
          </div>
        </div>

        <div className={classes.pillsPhone}>
          <div
            className={classes.pills}
            role='tablist'
            aria-label={t('pages.main.mobileAppBanner.featuresAria')}
          >
            {FEATURES.map((key) => {
              const isActive = key === activeFeature;
              return (
                <button
                  key={key}
                  type='button'
                  role='tab'
                  aria-selected={isActive}
                  className={`${classes.pill} ${isActive ? classes.pillActive : ''}`}
                  onClick={() => setActiveFeature(key)}
                >
                  {t(`pages.main.mobileAppBanner.features.${key}`)}
                </button>
              );
            })}
          </div>

          <div className={classes.phone} aria-hidden='true'>
            <img src={phoneImg} alt='' />
          </div>
        </div>

        <div
          className={classes.qr}
          role='img'
          aria-label={t('pages.main.mobileAppBanner.qrAria')}
        >
          <img src={qrImg} alt='' />
        </div>
      </div>
    </section>
  );
};

export default MobileAppBanner;
